class Hamburger {
  constructor(el) {
    this.dom = {el: el};
    this.dom.trigger = this.dom.el;
    this.dom.menu = document.querySelector('#menu');
    this.dom.closer = document.querySelectorAll('[data-js="closer"]');
    this.dom.body = document.querySelector('body');

    this.dom.reservationTrigger = document.querySelector('[data-js="reservation-trigger"]');
    this.dom.reservation = document.querySelector('#reservation');

    this.isMenuOpen = false;
    this.isReservationOpen = false;

    this.toggleMenu = this.toggleMenu.bind(this);

    this.mql = window.matchMedia('screen and (min-width: 768px)');
    this.checkBreakPoint = this.checkBreakPoint.bind(this);

    this.init();
  }

  init() {
    this.dom.trigger.addEventListener('click', e => {
      this.toggleMenu();
    });
    [...this.dom.closer].forEach(el=>{
      el.addEventListener('click', e => {
        this.toggleMenu();
      });
    })

    // 予約メニューの表示    
    // this.dom.reservationTrigger.addEventListener('click', (e) => {
    //   if (!e.currentTarget.dataset.is) {
    //     e.currentTarget.dataset.is = 'search';
    //   } else {
    //     e.currentTarget.removeAttribute('data-is');
    //   }
    //   this.toggleReservation();
    // });
    
    // ブレイクポイントの瞬間に発火
    this.mql.addListener(this.checkBreakPoint);
    // 初回チェック
    this.checkBreakPoint(this.mql);
  }

  toggleMenu() {
    if (this.isMenuOpen) {
      this.dom.trigger.setAttribute('aria-expanded', false);
      this.dom.menu.setAttribute('aria-hidden', true);
      this.scrollEnable();
    } else {
      this.dom.trigger.setAttribute('aria-expanded', true);
      this.dom.menu.setAttribute('aria-hidden', false);
      this.isReservationOpen = false;
      this.scrollDisable();
    }

    if (document.body.dataset.isMenu === 'true') {
      document.body.removeAttribute('data-is-menu');
    } else {
      document.body.dataset.isMenu = 'true';
      // document.body.removeAttribute('data-is-reservation');
    }

    this.isMenuOpen = !this.isMenuOpen;
  }

  toggleReservation() {
    if (this.isReservationOpen) {
      this.dom.trigger.setAttribute('aria-expanded', false);
      this.dom.reservation.setAttribute('aria-hidden', true);
      this.scrollEnable();
    } else {
      this.dom.trigger.setAttribute('aria-expanded', true);
      this.dom.reservation.setAttribute('aria-hidden', false);
      this.isMenuOpen = false;
      this.scrollDisable();
    }

    if (document.body.dataset.isReservation === 'true') {
      document.body.removeAttribute('data-is-reservation');
    } else {
      document.body.dataset.isReservation = 'true';
      document.body.removeAttribute('data-is-menu');
    }

    this.isReservationOpen = !this.isReservationOpen;
  }

	scrollDisable() {
    document.body.dataset.isScrolldisable = 'true';
	}

	scrollEnable() {
    document.body.removeAttribute('data-is-scrolldisable');
	}

  checkBreakPoint(_mql) {
		if (!_mql.matches) {
      // console.log('sp');
      return;
    } else {
      // console.log('pc');
      if (this.isMenuOpen) {
        this.dom.trigger.setAttribute('aria-expanded', false);
        this.dom.menu.setAttribute('aria-hidden', true);
        this.scrollEnable();

        this.isMenuOpen = !this.isMenuOpen;
        if (document.body.dataset.isMenu === 'true') {
          document.body.removeAttribute('data-is-menu');
          document.body.removeAttribute('data-is-reservation');
        } else {
          document.body.dataset.isMenu = 'true';
        }
      }

      // if (this.isReservationOpen) {
      //   this.dom.reservationTrigger.setAttribute('aria-expanded', false);
      //   this.dom.reservation.setAttribute('aria-hidden', true);
      //   this.scrollEnable();

      //   this.isReservationOpen = !this.isReservationOpen;
      //   if (document.body.dataset.isReservation === 'true') {
      //     document.body.removeAttribute('data-is-reservation');
      //   } else {
      //     document.body.dataset.isReservation = 'true';
      //   }
      // }
      return;
		}
	}
}

export default Hamburger